/**
 * Cockpit API - Territory
 *
 * Contact: info@formunauts.at
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpParams,
  HttpResponse,
  HttpEvent,
  HttpParameterCodec,
  HttpContext,
} from '@angular/common/http';
import { CustomHttpParameterCodec } from '../encoder';
import { Observable } from 'rxjs';

// @ts-ignore
import { AssignmentPageResponse } from '../model/assignment-page-response.api-model';
// @ts-ignore
import { AssignmentResponse } from '../model/assignment-response.api-model';
// @ts-ignore
import { AssignmentStatus } from '../model/assignment-status.api-model';
// @ts-ignore
import { CreateAssignmentRequest } from '../model/create-assignment-request.api-model';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { FmntsCockpitApiConfiguration } from '../configuration';
import { BaseService } from '../api.base.service';

export interface AssignmentDeleteRequestParams {
  /** The id of the assignment to get. */
  id: string;
}

export interface AssignmentGetRequestParams {
  /** The id of the assignment to get. */
  id: string;
}

export interface AssignmentsCreateRequestParams {
  CreateAssignmentRequest?: CreateAssignmentRequest;
}

export interface AssignmentsListRequestParams {
  /** A page number within the paginated result set.  */
  page?: number;
  /** Number of results to return per page.  */
  page_size?: number;
  /** Filters the result by a case insensitve substring match on name of territory, organization and agency.  */
  search?: string;
  /** Filters the result by assignments that would be active after &#x60;assigned_after&#x60; and before &#x60;assigned_before&#x60;. Must be used in conjuction with &#x60;assigned_before&#x60;.  */
  assigned_after?: string;
  /** Filters the result by assignments that would be active after &#x60;assigned_after&#x60; and before &#x60;assigned_before&#x60;. Must be used in conjuction with &#x60;assigned_after&#x60;.  */
  assigned_before?: string;
  /** Filters the result by assignments that are related to one of those organization ids. */
  organization_id?: ReadonlyArray<number>;
  /** Filters the result by assignments that are related to one of those agency ids. */
  agency_id?: ReadonlyArray<number>;
  /** Filters the result by status. */
  status?: ReadonlyArray<AssignmentStatus>;
}

@Injectable({
  providedIn: 'root',
})
export class AssignmentsApi extends BaseService {
  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string | string[],
    @Optional() configuration?: FmntsCockpitApiConfiguration,
  ) {
    super(basePath, configuration);
  }

  /**
   * Delete an assignment.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public assignmentDelete(
    requestParameters: AssignmentDeleteRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any>;
  public assignmentDelete(
    requestParameters: AssignmentDeleteRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<any>>;
  public assignmentDelete(
    requestParameters: AssignmentDeleteRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<any>>;
  public assignmentDelete(
    requestParameters: AssignmentDeleteRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error(
        'Required parameter id was null or undefined when calling assignmentDelete.',
      );
    }

    let localVarHeaders = this.defaultHeaders;

    // authentication (BearerAuth) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'BearerAuth',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        'Accept',
        localVarHttpHeaderAcceptSelected,
      );
    }

    const localVarHttpContext: HttpContext =
      options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (
        this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)
      ) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/territory/assignments/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/`;
    return this.httpClient.request<any>(
      'delete',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * Get details for a assignment by &#x60;id&#x60;.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public assignmentGet(
    requestParameters: AssignmentGetRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<AssignmentResponse>;
  public assignmentGet(
    requestParameters: AssignmentGetRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<AssignmentResponse>>;
  public assignmentGet(
    requestParameters: AssignmentGetRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<AssignmentResponse>>;
  public assignmentGet(
    requestParameters: AssignmentGetRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error(
        'Required parameter id was null or undefined when calling assignmentGet.',
      );
    }

    let localVarHeaders = this.defaultHeaders;

    // authentication (BearerAuth) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'BearerAuth',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        'Accept',
        localVarHttpHeaderAcceptSelected,
      );
    }

    const localVarHttpContext: HttpContext =
      options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (
        this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)
      ) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/territory/assignments/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/`;
    return this.httpClient.request<AssignmentResponse>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * Create an assignment in order to allocate fundraising efforts to specific areas, ensure each territory is assigned to the correct agency, and avoid overlaps or overuse of territories.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public assignmentsCreate(
    requestParameters?: AssignmentsCreateRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<AssignmentResponse>;
  public assignmentsCreate(
    requestParameters?: AssignmentsCreateRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<AssignmentResponse>>;
  public assignmentsCreate(
    requestParameters?: AssignmentsCreateRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<AssignmentResponse>>;
  public assignmentsCreate(
    requestParameters?: AssignmentsCreateRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    const CreateAssignmentRequest = requestParameters?.CreateAssignmentRequest;

    let localVarHeaders = this.defaultHeaders;

    // authentication (BearerAuth) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'BearerAuth',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        'Accept',
        localVarHttpHeaderAcceptSelected,
      );
    }

    const localVarHttpContext: HttpContext =
      options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        'Content-Type',
        httpContentTypeSelected,
      );
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (
        this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)
      ) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/territory/assignments/`;
    return this.httpClient.request<AssignmentResponse>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: CreateAssignmentRequest,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * Return a paginated list of assignments
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public assignmentsList(
    requestParameters?: AssignmentsListRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<AssignmentPageResponse>;
  public assignmentsList(
    requestParameters?: AssignmentsListRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpResponse<AssignmentPageResponse>>;
  public assignmentsList(
    requestParameters?: AssignmentsListRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<HttpEvent<AssignmentPageResponse>>;
  public assignmentsList(
    requestParameters?: AssignmentsListRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'application/json';
      context?: HttpContext;
      transferCache?: boolean;
    },
  ): Observable<any> {
    const page = requestParameters?.page;
    const page_size = requestParameters?.page_size;
    const search = requestParameters?.search;
    const assigned_after = requestParameters?.assigned_after;
    const assigned_before = requestParameters?.assigned_before;
    const organization_id = requestParameters?.organization_id;
    const agency_id = requestParameters?.agency_id;
    const status = requestParameters?.status;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      <any>page,
      'page',
    );
    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      <any>page_size,
      'page_size',
    );
    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      <any>search,
      'search',
    );
    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      <any>assigned_after,
      'assigned_after',
    );
    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      <any>assigned_before,
      'assigned_before',
    );
    if (organization_id) {
      organization_id.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'organization_id',
        );
      });
    }
    if (agency_id) {
      agency_id.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'agency_id',
        );
      });
    }
    if (status) {
      status.forEach((element) => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'status',
        );
      });
    }

    let localVarHeaders = this.defaultHeaders;

    // authentication (BearerAuth) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'BearerAuth',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        'Accept',
        localVarHttpHeaderAcceptSelected,
      );
    }

    const localVarHttpContext: HttpContext =
      options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (
        this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)
      ) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/territory/assignments/`;
    return this.httpClient.request<AssignmentPageResponse>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress,
      },
    );
  }
}
